<template>
  <div class="card mb-25 border-0 rounded-0 bg-white add-user-card">
    <div class="card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing"  v-if="auth.can('ADD_CUSTOMER')">
      <form @submit.prevent="handleSubmit">
        <div class="row">
          <!-- Profile Image -->
          <div class="col-md-12 mb-20">
            <label class="d-block text-black fw-semibold mb-10">
              Photo de profil
            </label>
            <div class="d-flex align-items-center">
              <img
                v-if="imagepreview"
                :src="imagepreview"
                class="rounded-circle me-15"
                style="width: 90px; height: 90px; object-fit: cover"
              />
              <img
                v-else
                :src="require('@/assets/images/NoImage.png')"
                class="rounded-circle me-15"
                style="width: 90px; height: 90px; object-fit: cover"
              />
              <div>
                <input
                  ref="updateImgInput"
                  type="file"
                  accept="image/*"
                  class="d-none"
                  @change="logoSelected"
                />
                <button
                  type="button"
                  class="btn btn-primary me-2"
                  @click="() => updateImgInput?.click()"
                >
                  Choisir la photo
                </button>
                <button
                  type="button"
                  class="btn btn-outline-secondary"
                  @click="cancelImage"
                >
                  Annuler
                </button>
              </div>
            </div>
          </div>

          <!-- Nom complet -->
          <div class="col-md-6 mb-20">
            <label class="d-block text-black fw-semibold mb-10"
              >Nom complet *</label
            >
            <input
              v-model="newUser.name"
              type="text"
              class="form-control shadow-none rounded-0"
              placeholder="Nom complet"
              @change="checkName"
              required
            />
          </div>

          <!-- CIN -->
          <div class="col-md-6 mb-20">
            <label class="d-block text-black fw-semibold mb-10">CIN *</label>
            <input
              v-model="newUser.cin"
              type="text"
              class="form-control shadow-none rounded-0"
              placeholder="CIN"
              required
            />
          </div>

          <!-- Pièces Jointes -->
          <div class="col-12 mb-20">
            <label class="d-block text-black fw-semibold mb-10"
              >(Pièces Jointes) CIN</label
            >
            <input
              type="file"
              class="form-control shadow-none rounded-0"
              @change="fileSelected"
              multiple
              accept="image/*"
            />
            <div
              v-for="(attachment, index) in attachments"
              :key="index"
              class="mt-2"
            >
              <span class="badge bg-primary">
                {{ attachment.name }} ({{
                  (attachment.size / 1024 / 1024).toFixed(1)
                }}MB)
              </span>
            </div>
            <div class="mt-2">
              <img
                v-for="(url, index) in urls"
                :key="index"
                :src="url"
                class="me-2 mb-2"
                height="120"
              />
              <button
                v-if="urls.length > 0"
                type="button"
                class="btn btn-warning rounded-circle"
                @click="removeFiles"
              >
                X
              </button>
            </div>
          </div>

          <!-- Adresse electronique -->
          <div class="col-md-6 mb-20">
            <label class="d-block text-black fw-semibold mb-10"
              >Adresse electronique *</label
            >
            <input
              v-model="newUser.email"
              type="email"
              class="form-control shadow-none rounded-0"
              placeholder="Adresse electronique"
              @change="checkEmail"
              required
            />
            <small class="text-danger" v-if="erroremail"
              >Email éléctronique déja existe</small
            >
          </div>

          <!-- Nom du magasin -->
          <div class="col-md-6 mb-20">
            <label class="d-block text-black fw-semibold mb-10"
              >Nom du magasin *</label
            >
            <input
              v-model="newUser.store"
              type="text"
              class="form-control shadow-none rounded-0"
              placeholder="Nom du magasin"
              @change="checkStore"
              required
            />
            <small class="text-danger" v-if="errorstore"
              >Magazin déja existe</small
            >
          </div>

          <!-- Numéro de téléphone -->
          <div class="col-md-6 mb-20">
            <label class="d-block text-black fw-semibold mb-10"
              >Numéro de téléphone *</label
            >
            <input
              v-model="newUser.phone"
              type="text"
              class="form-control shadow-none rounded-0"
              placeholder="Numéro de téléphone"
              @change="checkPhone"
              required
            />
            <small class="text-danger" v-if="errorphone"
              >Ce numéro téléphone déja existe</small
            >
          </div>

          <!-- Numéro de téléphone personnel -->
          <div class="col-md-6 mb-20">
            <label class="d-block text-black fw-semibold mb-10"
              >Numéro de téléphone (Personnel)</label
            >
            <input
              v-model="newUser.p_phone"
              type="text"
              class="form-control shadow-none rounded-0"
              placeholder="Numéro de téléphone (Personnel)"
            />
          </div>

          <!-- Mot de passe -->
          <div class="col-md-6 mb-20">
            <label class="d-block text-black fw-semibold mb-10"
              >Mot de passe *</label
            >
            <input
              v-model="newUser.password"
              type="password"
              class="form-control shadow-none rounded-0"
              placeholder="Mot de passe"
              required
            />
          </div>

          <!-- Confirmation de mot de passe -->
          <div class="col-md-6 mb-20">
            <label class="d-block text-black fw-semibold mb-10"
              >Confirmation de mot de passe *</label
            >
            <input
              v-model="newUser.c_password"
              type="password"
              class="form-control shadow-none rounded-0"
              placeholder="Confirmation de mot de passe"
              required
            />
          </div>

          <!-- Ville -->
          <div class="col-12 mb-20">
            <label class="d-block text-black fw-semibold mb-10">Ville *</label>
            <select
              v-model="newUser.city"
              class="form-select shadow-none rounded-0"
              required
            >
              <option v-for="(c, i) in citiesList" :key="i" :value="c">
                {{ c.name }}
              </option>
            </select>
          </div>

          <!-- Adresse -->
          <div class="col-12 mb-20">
            <label class="d-block text-black fw-semibold mb-10"
              >Adresse *</label
            >
            <textarea
              v-model="newUser.adresse"
              rows="2"
              class="form-control shadow-none rounded-0"
              placeholder="Adresse"
              required
            ></textarea>
          </div>

          <div class="col-md-6 mb-20">
            <label class="d-block text-black fw-semibold mb-10"
              >Site web *</label
            >
            <input
              v-model="newUser.website"
              type="url"
              class="form-control shadow-none rounded-0"
              placeholder="Site web *"
            />
          </div>

          <div class="col-md-6 mb-20">
            <label class="d-block text-black fw-semibold mb-10">Marque *</label>
            <input
              v-model="newUser.brand"
              type="text"
              class="form-control shadow-none rounded-0"
              placeholder="Marque *"
            />
          </div>

          <div class="col-md-6 mb-20">
            <label class="d-block text-black fw-semibold mb-10"
              >Type d'entereprise *</label
            >
            <select
              v-model="newUser.client_type"
              class="form-select shadow-none rounded-0"
              required
            >
              <option v-for="(c, i) in typeClients" :key="i" :value="c">
                {{ c.name }}
              </option>
            </select>
          </div>

          <div class="col-md-6 mb-20">
            <label class="d-block text-black fw-semibold mb-10"
              >Registre de commerce</label
            >
            <input
              v-model="newUser.rc"
              type="text"
              class="form-control shadow-none rounded-0"
              placeholder="Registre de commerce"
            />
          </div>

          <!-- Submit -->
          <div
            class="col-md-12 d-flex align-items-center justify-content-between mt-20"
          >
            <button type="submit" class="btn btn-success px-4 py-2">
              Enregistrer
              <span
                v-if="loading"
                class="spinner-border spinner-border-sm ms-2"
              ></span>
            </button>
            <button type="button" class="btn btn-link text-danger">
              Annuler
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script lang="ts">
import api from "@/utils/axios";
import { useToast, POSITION } from "vue-toastification";
import { defineComponent, onMounted, reactive, ref } from "vue";
import { useAppToast } from "@/composables/useAppToast";
import router from "@/router";
import { useAuthStore } from "@/stores/auth";
// import ImageUpload from "./ImageUpload.vue";

export default defineComponent({
  name: "AddUser",
  components: {
    // ImageUpload,
  },
  setup: () => {
    const auth = useAuthStore();


    const updateImgInput = ref<HTMLInputElement | null>(null);
    const imagepreview = ref<string | null>(null);
    const substrPhone = ref<File[]>([]);
    const urls = ref<string[]>([]);
    const loading = ref(false);

    let errorname = ref(false);
    let errorstore = ref(false);
    let erroremail = ref(false);
    let errorphone = ref(false);
    let Riberror = ref(false);

    // Example static lists

    interface City {
      id: number;
      name: string;
    }
    const typeClients = ref<any[]>([]);
    const citiesList = ref<City[]>([]);
    const { showToast } = useAppToast();
    const attachments = ref<File[]>([]);

    const newUser = reactive({
      name: "",
      cin: "",
      phone: "",
      email: "",
      password: "",
      c_password: "",
      p_phone: "",
      adresse: "",
      store: "",
      city: null as City | null,
      attachments: [] as File[],
      image: null as File | null,
      website: "",
      brand: "",
      rib: "",
      client_type: null as City | null,
      rc: "",
    });

    onMounted(async () => {
      try {
        const response = await api.get("/api/auth/citiesList");
        if (response && response.data) {
          citiesList.value = response.data;
        }
      } catch (error) {
        console.error("Error fetching agencies:", error);
      }

      // zones
      try {
        const response = await api.get("/api/auth/typeClients");
        if (response && response.data) {
          typeClients.value = response.data;
        }
      } catch (error) {
        console.error("Error fetching agencies:", error);
      }
    });

    const logoSelected = (e: Event) => {
      const target = e.target as HTMLInputElement;
      const file = target.files?.[0];

      if (file) {
        newUser.image = file; // use the 'file' variable instead of re-accessing target.files
        imagepreview.value = URL.createObjectURL(file);
      }
    };

    const cancelImage = () => {
      imagepreview.value = null;
      if (updateImgInput.value) updateImgInput.value.value = "";
    };

    const fileSelected = (e: Event) => {
      const files = Array.from((e.target as HTMLInputElement).files || []);
      attachments.value = files;
      urls.value = files.map((f) => URL.createObjectURL(f));
    };

    const removeFiles = () => {
      attachments.value = [];
      urls.value = [];
    };

    const getFees = (zone: any) => {
      // fetch fees for selected zone
      console.log("Fetch fees for", zone);
    };

    const handleSubmit = async () => {
        console.log(errorname ) 
      if (newUser.password !== newUser.c_password) {
        console.error("Passwords do not match");
        showToast("Merci de verifier les mots de passe", "error");
        return;
      }

      if (errorname.value || errorstore.value || erroremail.value || errorphone.value ) {
        showToast("Merci de verifier vos information", "error");
        return;
      }

      const data = new FormData();
      // Safely handle nullable client_type
      if (newUser.client_type) {
        data.append("type_client", newUser.client_type.id.toString());
        data.append("company_type", newUser.client_type.name);
      }

      // Safely handle nullable city
      data.append("city", newUser.city?.name.toString() || "");
      data.append("city_id", newUser.city?.id.toString() || "");

      // Safely handle nullable image
      if (newUser.image) data.append("logo", newUser.image);

      // Safely handle nullable website
      // Other required fields
      data.append("adresse", newUser.adresse);
      data.append("c_password", newUser.c_password);
      data.append("password", newUser.password);
      data.append("email", newUser.email);
      data.append("phone", newUser.phone);
      data.append("p_phone", newUser.p_phone);
      data.append("cin", newUser.cin);
      data.append("name", newUser.name);
      data.append("magasin", newUser.store);
      data.append("brand", newUser.brand);
      data.append("website", newUser.website);

      data.append("rc", newUser.rc);
      for (let i = 0; i < newUser.attachments.length; i++) {
      data.append("attachments[]", newUser.attachments[i]);
      }

      try {
        console.log("Submitting form with data:", data);
        loading.value = true;
        const res = await api.post(`/api/auth/customer_add`, data, {headers: { "Content-Type": "multipart/form-data" }});
        console.log(res);

        if (res.data === "success" || res.data.success) {
          showToast("Utilisateur est bien ajouté", "success");
          router.push("/customers-list");
        } else if (res.data === "not match") {
          showToast("Merci de verifier les mots de passe", "error");
        } else {
          showToast("Erreur lors de l'ajout de l'utilisateur", "error");
        }
      } catch (err) {
        console.error("Error submitting form:", err);
      } finally {
        loading.value = false;
      }
    };

    async function checkName() {
      let data = new FormData();
      data.append("name", newUser.name);
          errorname.value = false;
      const res = await api.post(`/api/auth/CheckName`, data).then((res) => {
        if (res.data == "exist") {
          errorname.value = true;
          showToast("Nom client est deja existe", "error");
        } else if (res.data == "success") {
          errorname.value = false;
        }
      });
    }
    async function checkEmail() {
      let data = new FormData();
      data.append("email", newUser.email);
      const res = await api.post(`/api/auth/CheckEmail`, data).then((res) => {
        if (res.data == "exist") {
          erroremail.value = true;
          showToast("Email client est deja existe", "error");
        } else if (res.data == "success") {
          erroremail.value = false;
        }
      });
    }
    async function checkStore() {
      errorstore.value = false;
      let data = new FormData();
      data.append("magasin", newUser.store);
      const res = await api.post(`/api/auth/CheckStore`, data).then((res) => {
        if (res.data == "exist") {
          errorstore.value = true;
          showToast("Nom magasin est deja existe", "error");
        } else if (res.data == "success") {
          errorstore.value = false;
        }
      });
    }
    async function checkPhone() {
      let data = new FormData();
      data.append("phone", newUser.phone);
      errorphone.value = false;
      const res = await api.post(`/api/auth/CheckPhone`, data).then((res) => {
        if (res.data == "exist") {
          errorphone.value = true;
          showToast("Numéro téléphone existe", "error");
        } else if (res.data == "success") {
          errorphone.value = false;
        }
      });
    }
    async function checkRib() {
      let data = new FormData();
      data.append("rib", newUser.rib);
      Riberror.value = false;
      const res = await api.post(`/api/auth/CheckRib`, data).then((res) => {
        if (res.data.message == "exist") {
          Riberror.value = true;
          showToast("Numéro RIB est deja existe", "error");
        }
      });
    }

    return {
      updateImgInput,
      imagepreview,
      attachments,
      urls,
      newUser,
      citiesList,
      typeClients,
      loading,
      logoSelected,
      cancelImage,
      fileSelected,
      removeFiles,
      getFees,
      handleSubmit,

      checkRib,
      checkName,
      checkEmail,
      checkStore,
      checkPhone,

      errorname,
      errorstore,
      erroremail,
      errorphone,
      Riberror,

      auth
    };
  },
});
</script>